import { Controller } from 'stimulus'
import './component.scss'

import 'PackWerkNurikaeSite/pages/about/consult/index/partials/line_link/component'
import 'PackWerkNurikaeSite/pages/about/consult/index/partials/contact_nurikae/component'

import './images/mainvisual_pc.png'
import './images/mainvisual_sp.png'
import './images/chat_sample_case01.png'
import './images/chat_sample_case02.png'
import './images/chat_sample_case03.png'
import './images/chat_sample_case04.png'
import './images/button_line_consult_pc.png'
import './images/button_line_consult_sp.png'
import './images/button_telephone_consult_pc.png'
import './images/button_telephone_consult_sp.png'
import './images/button_event_list_pc.png'
import './images/button_event_list_sp.png'
import './images/nurikae_advisor_pc.png'
import './images/nurikae_advisor_sp.png'

// 画像のスクロールアニメーション
window.Stimulus.register(
  'consult-fade-in',
  class extends Controller {
    static targets = ['image'];

    connect () {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.5 })

      this.imageTargets.forEach(target => {
        observer.observe(target)
      })
    }
  }
)
